/* unplugin-vue-components disabled */import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=ad4f2e90&lang=less"

const __exports__ = script;

export default __exports__